import { Chip, Stack, type ChipProps } from '@mui/material';
import type { DocumentGroup } from '../../services/partnerOnboardingService';
import { groupZoneChipItems } from '../../utils/documentReviewUtils';

interface Props {
  group: Pick<DocumentGroup, 'zoneId' | 'zoneIds'>;
  zones?: Array<{ _id: string; name?: string; code?: string }>;
  chipProps?: ChipProps;
}

export default function GroupZoneChips({ group, zones, chipProps }: Props) {
  const items = groupZoneChipItems(group, zones);
  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
      {items.map((z) => (
        <Chip
          key={z.id}
          size="small"
          variant="outlined"
          label={z.label}
          sx={{ height: 22, maxWidth: '100%', '& .MuiChip-label': { whiteSpace: 'normal' } }}
          {...chipProps}
        />
      ))}
    </Stack>
  );
}
